// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';

// Initial State
const initialState = {
    loading: false,
    error: null,
    wordPressUserStatus: false,
    paidWaitlistStatus: false
};

// COLLAB CENTER GIFTED API
export const getWordPressUserStatusAPIFn = createAsyncThunk(
    'collabCenter/gifted',
    async (values, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${endPoints.wordPressUserStatusURL}?email=${encodeURIComponent(values?.email)}`);
            return data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data);
        }
    }
);

// COLLAB CENTER PAID API
export const getCreatorWaitListStatusAPIFn = createAsyncThunk(
    'collabCenter/paid',
    async (values, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${endPoints.creatorWaitlistStatusURL}?userId=${values?.userId}`);
            return data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data);
        }
    }
);


// COLLAB CENTER SLICE
export const collabCenterSlice = createSlice({
    name: 'collabCenter',
    initialState,
    extraReducers: builder => {
        builder // COLLAB CENTER GIFTED DATA
            .addCase(getWordPressUserStatusAPIFn.pending, state => {
                state.loading = true;
                state.error = null;
                state.wordPressUserStatus = null;
            })
            .addCase(getWordPressUserStatusAPIFn.fulfilled, (state, action) => {
                state.loading = false;
                state.wordPressUserStatus = action.payload.userStatus || true;
                state.error = null;
            })
            .addCase(getWordPressUserStatusAPIFn.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.wordPressUserStatus = null;
            })
            // COLLAB CENTER PAID DATA 
            .addCase(getCreatorWaitListStatusAPIFn.pending, state => {
                state.loading = true;
                state.error = null;
                state.paidWaitlistStatus = false;
            })
            .addCase(getCreatorWaitListStatusAPIFn.fulfilled, (state, action) => {
                state.loading = false;
                state.paidWaitlistStatus = action.payload || false;
                state.error = null;
            })
            .addCase(getCreatorWaitListStatusAPIFn.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.paidWaitlistStatus = null;
            })
    }
});

export default collabCenterSlice.reducer;
